import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import FilterBar from "components/Common/FilteringBar";
import ModalServicePrice from "components/Modals/ModalServicePrice";
import TableComponent from "../../components/Common/TableComponent";
import ButtonAdd from "components/Common/ButtonAdd.js";
import { translateMonthEnumValue } from "helpers/translateHardcodedData";
import { GetData } from "../../helpers/CRUD.js";
import i18next from "i18next";
import Pagination from "components/Common/Pagination";
import PaginationSelect from "components/Common/PaginationSelect";
import * as endpoints from "constants/endpoints";

const ServicePrice = (props) => {
  const [state, setState] = useState({
    pageTitle: i18next.t("link-service-price"),
    service_prices: [],
    isLoading: false,
    isLoaded: false,
    page: 1,
    totalCount: null,
    pageSize: 100,
    sorterLabel: "",
    sorterDirection: "",
    isModalOpen: false,
    isActive: true,
  });

  const location = useLocation();

  const emitErrors = (error) => {
    props.onErrorsShow(error.body);
  };

  const emitSuccess = (success) => {
    props.onSuccessShow(success);
  };

  const openModal = () => {
    setState((state) => ({ ...state, isModalOpen: !state.isModalOpen }));
    removeBodyCss();
  };

  const closeModal = () => {
    setState((state) => ({ ...state, isModalOpen: false }));
    removeBodyCss();
  };

  const closeAndUpdate = (modalCallback) => {
    setState((state) => ({ ...state, isModalOpen: false }));
    modalCallback();
    removeBodyCss();
  };

  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const getAllActive = () => {
    setState((state) => ({
      ...state,
      isLoaded: false,
      service_prices: [],
    }));

    let endpointSortAdd = "";

    if (state.sorterLabel !== "") {
      endpointSortAdd = `&orderBy=`;

      if (state.sorterLabel.includes(",")) {
        state.sorterLabel.split(",").map((item, i) => {
          endpointSortAdd = `${endpointSortAdd}${i > 0 ? "," : ""}${item}_${
            state.sorterDirection
          }`;
        });
      } else {
        endpointSortAdd = `&orderBy=${state.sorterLabel}_${state.sorterDirection}`;
      }
    }

    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/ServicePrice/GetAll?filterText=&page=${state.page}&size=${state.pageSize}${endpointSortAdd}&isActive=${state.isActive}`;

    GetData(
      url,
      (data) => {
        let tableBodyData;

        if (data) {
          tableBodyData = data.items.map((item) => {
            return {
              id: item.id,
              data: {
                startDate: `${translateMonthEnumValue(item.startMonth)} ${
                  item.startYear
                }`,
                endDate: `${translateMonthEnumValue(item.endMonth)} ${
                  item.endYear
                }`,
                pricePerHeatCostAllocator: item.pricePerHeatCostAllocator,
                pricePerWaterMeter: item.pricePerWaterMeter,
                pricePerHeatMeter: item.pricePerHeatMeter,
                pricePerEstate: item.pricePerEstate,
                isActive: item.isActive,
              },
            };
          });
        }

        setState((state) => ({
          ...state,
          service_prices: tableBodyData,
          isLoaded: true,
          totalCount: data.totalCount,
        }));
      },
      (error) => {
        props.onErrorsShow(error.body);
      }
    );
  };

  const updatePage = (page) => {
    setState((state) => ({ ...state, page }));
  };

  const onPageSizeUpdate = (pageSize) => {
    setState((state) => ({ ...state, pageSize, page: 1 }));
  };

  const onSorterClick = (label, direction) => {
    setState((state) => ({
      ...state,
      page: 1,
      sorterLabel: label,
      sorterDirection: direction,
    }));
  };

  useEffect(() => {
    getAllActive();
  }, [state.page, state.pageSize, state.isActive]);

  useEffect(() => {
    onPageSizeUpdate(state.pageSize);
  }, [state.isActive]);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setState((state) => ({
      ...state,
      loggedUserType: obj.role,
      isLoading: true,
    }));

    if (location.state) {
      setState((state) => ({ ...state, mode: "edit" }));
    }
  }, []);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <CardTitle className="mb-4">{state.pageTitle}</CardTitle>
                </Col>

                <Col md="2" className="ml-auto mr-0">
                  <PaginationSelect
                    pageSize={state.pageSize}
                    index={1}
                    onPageSizeUpdate={onPageSizeUpdate}
                  />
                </Col>

                <Col className="text-right col-md-1">
                  <ButtonAdd
                    onBtnClick={openModal}
                    data-toggle="modal"
                    tooltip="Добави нов период на изравняване"
                  />
                </Col>
              </Row>

              <FilterBar
                tableData={state.service_prices}
                isActive
                className="fle"
                state={state}
                setState={setState}
              ></FilterBar>

              <TableComponent
                dataHead={[
                  i18next.t("start-period"),
                  i18next.t("end-period"),
                  i18next.t("price-hca"),
                  i18next.t("price-watermeter"),
                  i18next.t("price-apartment-meter"),
                  i18next.t("price-service"),
                  i18next.t("actions"),
                ]}
                dataBody={state.service_prices}
                sorterData={[
                  "startYear,startMonth",
                  "endYear,endMonth",
                  "pricePerHeatCostAllocator",
                  "pricePerWaterMeter",
                  "pricePerHeatMeter",
                  "pricePerEstate",
                ]}
                onSorterClick={onSorterClick}
                url_path={"service-price"}
                category={"service-price"}
                enableLinkView={true}
                isLoading={state.isLoading}
                isLoaded={state.isLoaded}
              />

              <Pagination
                updatePage={updatePage}
                page={state.page}
                totalCount={state.totalCount}
                pageSize={state.pageSize}
              />

              <ModalServicePrice
                isModalOpen={state.isModalOpen}
                closeModal={closeModal}
                update={() => closeAndUpdate(getAllActive)}
                emitErrors={emitErrors}
                emitSuccess={emitSuccess}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

ServicePrice.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ServicePrice));
